import React from "react";
import bannerTeste from "../../assets/images/banner-teste.png";
import { Container } from "reactstrap";

const Ui = () => {
  document.title = "Defender | UI Labolatory";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <img
            style={{ objectFit: "contain", width: "100%" }}
            src={bannerTeste}
          />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Ui;
